import React from "react";

export default props => (
  <svg
    {...props}
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(-263 -4355)">
      <path
        id="path0_fill"
        transform="translate(263 4355)"
        d="M 16.6667 15.555L 25.555 19.9917L 16.6667 24.445L 16.6667 15.555ZM 40 0L 40 40L 0 40L 0 0L 40 0ZM 33.3333 20C 33.3 13.1283 32.795 10.5 28.4617 10.205C 24.4567 9.93167 15.5383 9.93333 11.54 10.205C 7.21 10.5 6.7 13.1167 6.66667 20C 6.7 26.8717 7.205 29.5 11.5383 29.795C 15.5367 30.0667 24.455 30.0683 28.46 29.795C 32.79 29.5 33.3 26.8833 33.3333 20Z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/Icons/svg/Youtube/index.js